import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { HomeSchema, FAQSchema } from '@/components/SEOSchema';
import { pillarArticles } from '@/mocks/pillarArticles';
import { productCategories } from '@/mocks/products';
import { SITE_URL } from '@/lib/seo';

const featuredProducts = productCategories.flatMap((cat) => cat.products.slice(0, 1));

const categories = [
  { key: 'cat.shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', img: 'https://readdy.ai/api/search-image?query=Pair%20of%20clean%20white%20low-top%20sneakers%20photographed%20from%20a%20side%20angle%20on%20a%20soft%20sage%20green%20studio%20backdrop%2C%20minimalist%20e-commerce%20product%20photography%20with%20soft%20diffused%20lighting%2C%20crisp%20rubber%20sole%20and%20fabric%20texture%2C%20airy%20composition%20with%20gentle%20shadow%2C%20premium%20streetwear%20aesthetic&width=600&height=600&seq=cat-shoes-01&orientation=squarish&nocache=true' },
  { key: 'cat.hoodies', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html', img: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20terracotta%20hoodie%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20peach%20studio%20wall%2C%20minimalist%20fashion%20product%20photography%20with%20soft%20natural%20window%20light%2C%20visible%20cotton%20fleece%20texture%20and%20drawstrings%2C%20clean%20airy%20composition%2C%20editorial%20catalog%20style&width=600&height=600&seq=cat-hoodies-01&orientation=squarish&nocache=true' },
  { key: 'cat.tshirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html', img: 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20pastel%20yellow%20cotton%20t-shirts%20on%20a%20light%20cream%20surface%20viewed%20from%20above%2C%20flat%20lay%20product%20photography%20with%20soft%20diffused%20light%2C%20visible%20fabric%20weave%20and%20subtle%20wrinkles%2C%20minimal%20clean%20aesthetic%2C%20warm%20tones&width=600&height=600&seq=cat-tshirts-01&orientation=squarish&nocache=true' },
  { key: 'cat.jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html', img: 'https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20displayed%20on%20a%20mannequin%20against%20a%20soft%20mint%20studio%20backdrop%2C%20fashion%20product%20photography%20with%20soft%20even%20lighting%2C%20detailed%20zipper%20and%20fabric%20texture%2C%20clean%20minimal%20composition%2C%20premium%20streetwear%20editorial&width=600&height=600&seq=cat-jackets-01&orientation=squarish&nocache=true' },
  { key: 'cat.pants', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html', img: 'https://readdy.ai/api/search-image?query=Beige%20cargo%20pants%20laid%20flat%20with%20visible%20pockets%20and%20straps%20on%20a%20soft%20lavender%20studio%20surface%2C%20top-down%20product%20photography%20with%20soft%20diffused%20lighting%2C%20crisp%20fabric%20detail%20and%20stitching%2C%20minimal%20clean%20aesthetic&width=600&height=600&seq=cat-pants-01&orientation=squarish&nocache=true' },
  { key: 'cat.headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html', img: 'https://readdy.ai/api/search-image?query=Structured%20baseball%20cap%20in%20warm%20caramel%20brown%20on%20a%20light%20cream%20studio%20surface%2C%20product%20photography%20with%20soft%20directional%20light%2C%20visible%20embroidered%20detail%20and%20curved%20brim%2C%20clean%20minimal%20composition%2C%20streetwear%20style&width=600&height=600&seq=cat-headwear-01&orientation=squarish&nocache=true' },
  { key: 'cat.sets', url: 'https://kaspreadsheet.com/category-917-Sets.html', img: 'https://readdy.ai/api/search-image?query=Matching%20two-piece%20hoodie%20and%20jogger%20set%20in%20soft%20heather%20grey%20displayed%20together%20on%20a%20warm%20sand%20studio%20backdrop%2C%20coordinated%20outfit%20product%20photography%20with%20soft%20even%20light%2C%20clean%20minimal%20composition%2C%20premium%20loungewear%20editorial&width=600&height=600&seq=cat-sets-01&orientation=squarish&nocache=true' },
  { key: 'cat.underwear', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html', img: 'https://readdy.ai/api/search-image?query=Minimalist%20cotton%20underwear%20set%20in%20soft%20powder%20pink%20folded%20neatly%20on%20a%20bright%20white%20surface%2C%20product%20photography%20with%20soft%20diffused%20lighting%2C%20delicate%20fabric%20texture%20and%20clean%20lines%2C%20fresh%20airy%20aesthetic&width=600&height=600&seq=cat-underwear-01&orientation=squarish&nocache=true' },
  { key: 'cat.jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html', img: 'https://readdy.ai/api/search-image?query=Vintage-inspired%20football%20jersey%20in%20deep%20green%20with%20subtle%20stripes%20displayed%20flat%20on%20a%20warm%20cream%20studio%20surface%2C%20product%20photography%20with%20soft%20even%20light%2C%20visible%20mesh%20fabric%20and%20stitched%20numbers%2C%20clean%20minimal%20composition&width=600&height=600&seq=cat-jersey-01&orientation=squarish&nocache=true' },
  { key: 'cat.accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html', img: 'https://readdy.ai/api/search-image?query=Collection%20of%20minimalist%20jewelry%20and%20watches%20arranged%20on%20a%20warm%20beige%20stone%20surface%2C%20product%20photography%20with%20soft%20natural%20light%2C%20delicate%20metallic%20textures%20and%20clean%20spacing%2C%20premium%20editorial%20style&width=600&height=600&seq=cat-accessories-01&orientation=squarish&nocache=true' },
  { key: 'cat.bags', url: 'https://kaspreadsheet.com/category-921-Bags.html', img: 'https://readdy.ai/api/search-image?query=Structured%20canvas%20tote%20bag%20in%20warm%20tan%20with%20leather%20handles%20standing%20on%20a%20soft%20sage%20studio%20backdrop%2C%20product%20photography%20with%20soft%20directional%20light%2C%20visible%20canvas%20weave%20and%20stitching%2C%20clean%20minimal%20composition&width=600&height=600&seq=cat-bags-01&orientation=squarish&nocache=true' },
  { key: 'cat.belts', url: 'https://kaspreadsheet.com/category-922-Belts.html', img: 'https://readdy.ai/api/search-image?query=Coiled%20leather%20belt%20in%20rich%20brown%20with%20brushed%20metal%20buckle%20on%20a%20warm%20sand%20studio%20surface%2C%20product%20photography%20with%20soft%20even%20light%2C%20visible%20leather%20grain%20and%20stitching%20detail%2C%20clean%20minimal%20composition&width=600&height=600&seq=cat-belts-01&orientation=squarish&nocache=true' },
  { key: 'cat.perfumes', url: 'https://kaspreadsheet.com/category-923-Perfumes.html', img: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20a%20soft%20rose%20studio%20backdrop%2C%20product%20photography%20with%20soft%20diffused%20lighting%2C%20delicate%20reflections%20and%20clean%20spacing%2C%20premium%20luxury%20editorial&width=600&height=600&seq=cat-perfumes-01&orientation=squarish&nocache=true' },
  { key: 'cat.other', url: 'https://kaspreadsheet.com/category-924-Other+Stuff.html', img: 'https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20including%20sunglasses%2C%20wallet%20and%20keychain%20arranged%20on%20a%20light%20cream%20surface%2C%20product%20photography%20with%20soft%20natural%20light%2C%20clean%20minimal%20spacing%2C%20premium%20editorial%20style&width=600&height=600&seq=cat-other-01&orientation=squarish&nocache=true' },
];

const guides = [
  { key: 'guides.review', desc: 'guides.review.desc', icon: 'ri-star-line', img: 'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20fashion%20products%20with%20golden%20star%20rating%20symbols%20and%20a%20clipboard%20on%20a%20light%20cream%20pastel%20background%2C%20review%20and%20evaluation%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-review-01&orientation=landscape' },
  { key: 'guides.shipping', desc: 'guides.shipping.desc', icon: 'ri-truck-line', img: 'https://readdy.ai/api/search-image?query=Neatly%20stacked%20international%20shipping%20cardboard%20boxes%20and%20parcels%20with%20shipping%20labels%20on%20a%20light%20peach%20pastel%20background%2C%20logistics%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-shipping-01&orientation=landscape' },
  { key: 'guides.qc', desc: 'guides.qc.desc', icon: 'ri-camera-line', img: 'https://readdy.ai/api/search-image?query=Close-up%20inspection%20of%20sneakers%20and%20folded%20clothing%20with%20a%20measuring%20tape%20on%20a%20soft%20sage%20green%20pastel%20background%2C%20quality%20check%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-qc-01&orientation=landscape' },
  { key: 'guides.warehouse', desc: 'guides.warehouse.desc', icon: 'ri-building-line', img: 'https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelves%20filled%20with%20fashion%20product%20boxes%20and%20parcels%20on%20a%20light%20mint%20pastel%20background%2C%20logistics%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-warehouse-01&orientation=landscape' },
  { key: 'guides.legit', desc: 'guides.legit.desc', icon: 'ri-shield-check-line', img: 'https://readdy.ai/api/search-image?query=Shield%20and%20padlock%20concept%20with%20shopping%20bags%20and%20products%20on%20a%20light%20warm%20beige%20pastel%20background%2C%20trust%20and%20safety%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-legit-01&orientation=landscape' },
  { key: 'guides.coupon', desc: 'guides.coupon.desc', icon: 'ri-coupon-line', img: 'https://readdy.ai/api/search-image?query=Discount%20coupon%20tags%20and%20percent%20off%20labels%20arranged%20with%20shopping%20bags%20on%20a%20light%20yellow%20pastel%20background%2C%20promo%20and%20offer%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style&width=800&height=500&seq=guide-coupon-01&orientation=landscape' },
];

const faqs = [
  { q: 'faq.1.q', a: 'faq.1.a' },
  { q: 'faq.2.q', a: 'faq.2.a' },
  { q: 'faq.3.q', a: 'faq.3.a' },
  { q: 'faq.4.q', a: 'faq.4.a' },
  { q: 'faq.5.q', a: 'faq.5.a' },
  { q: 'faq.6.q', a: 'faq.6.a' },
  { q: 'faq.7.q', a: 'faq.7.a' },
  { q: 'faq.8.q', a: 'faq.8.a' },
];

export default function Home() {
  const { t, i18n } = useTranslation();
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const articlePath =
    i18n.language === 'pt' ? '/cssbuy-spreadsheet-guia/' :
    i18n.language === 'de' ? '/cssbuy-spreadsheet-anleitung/' : '/cssbuy-spreadsheet-guide/';

  const currentUrl = `${SITE_URL}${i18n.language === 'pt' ? '/' : `/${i18n.language}/`}`;

  const faqSchemaData = faqs.map((f) => ({
    question: t(f.q),
    answer: t(f.a),
  }));

  return (
    <div className="min-h-screen bg-background-50">
      <HomeSchema lang={i18n.language} url={currentUrl} />
      <FAQSchema faqs={faqSchemaData} />

      <Navbar />

      {/* Hero */}
      <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylish%20minimalist%20fashion%20collage%20featuring%20sneakers%2C%20a%20folded%20hoodie%2C%20sunglasses%20and%20a%20canvas%20tote%20bag%20arranged%20in%20an%20artistic%20grid%20on%20a%20soft%20warm%20cream%20background%2C%20premium%20editorial%20flat%20lay%20photography%20with%20soft%20natural%20shadows%2C%20clean%20airy%20composition%2C%20high%20detail%20textures%2C%20resource%20hub%20aesthetic&width=1600&height=900&seq=hero-main-01&orientation=landscape&nocache=true"
            alt="CSSBuy Spreadsheet Fashion Collection"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm font-medium px-4 py-2 rounded-full border border-white/20 mb-6">
              <i className="ri-shield-check-line" />
              {t('hero.badge')}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-6">
              {t('hero.title')}
            </h1>
            <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8 max-w-2xl mx-auto">
              {t('hero.subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-lg transition-colors whitespace-nowrap"
              >
                {t('hero.cta1')} <i className="ri-arrow-right-line" />
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium px-6 py-3 rounded-lg border border-white/25 transition-colors whitespace-nowrap"
              >
                {t('hero.cta2')}
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/70 text-sm">
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-primary-300" /> {t('hero.trust1')}</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-primary-300" /> {t('hero.trust2')}</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-primary-300" /> {t('hero.trust3')}</span>
              <span className="flex items-center gap-1.5"><i className="ri-check-line text-primary-300" /> {t('hero.trust4')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* What is */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600 mb-3 block">CSSBuy Spreadsheet</span>
          <h2 className="text-2xl md:text-4xl font-semibold mb-6">{t('what.title')}</h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6">
            {t('what.text')}
          </p>
          <p className="text-sm text-foreground-400 italic">
            {t('what.disclaimer')}
          </p>
        </div>
      </section>

      {/* Categories Grid */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100/50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-wider text-accent-600 mb-3 block">{t('nav.categories')}</span>
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('cats.title')}</h2>
            <p className="text-foreground-500 max-w-xl mx-auto">{t('cats.subtitle')}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {categories.map((c) => (
              <a
                key={c.key}
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                className="group relative bg-white rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all hover:shadow-md"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={c.img}
                    alt={t(c.key)}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-3">
                  <p className="text-xs font-medium text-foreground-700 text-center leading-tight">{t(c.key)}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Why Use */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('why.title')}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {['why.1', 'why.2', 'why.3', 'why.4', 'why.5', 'why.6', 'why.7', 'why.8'].map((k, i) => (
              <div key={k} className="bg-white rounded-xl border border-background-200/60 p-5 flex items-start gap-3 hover:border-primary-200 transition-colors">
                <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${['file-list-line', 'grid-line', 'book-open-line', 'camera-line', 'truck-line', 'building-line', 'exchange-line', 'shield-check-line'][i]} text-primary-600 text-sm`} />
                </div>
                <p className="text-sm font-medium text-foreground-700">{t(k)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100/50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('how.title')}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {['1', '2', '3', '4', '5', '6'].map((num) => (
              <div key={num} className="bg-white rounded-xl border border-background-200/60 p-6 relative">
                <span className="absolute top-4 right-4 text-4xl font-bold text-background-200/80 font-heading">{num}</span>
                <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`ri-${['search-line', 't-shirt-line', 'link-line', 'ruler-line', 'bar-chart-line', 'checkbox-circle-line'][parseInt(num) - 1]} text-primary-600`} />
                </div>
                <h3 className="text-lg font-semibold mb-2">{t(`how.${num}.title`)}</h3>
                <p className="text-sm text-foreground-500">{t(`how.${num}.text`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Guides */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-wider text-secondary-600 mb-3 block">{t('nav.guides')}</span>
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('guides.title')}</h2>
            <p className="text-foreground-500 max-w-xl mx-auto">{t('guides.subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {guides.map((g) => (
              <Link
                key={g.key}
                to={articlePath}
                className="group bg-white rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all hover:shadow-md"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={g.img}
                    alt={t(g.key)}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="w-9 h-9 rounded-full bg-accent-50 flex items-center justify-center mb-3">
                    <i className={`${g.icon} text-accent-600`} />
                  </div>
                  <h3 className="text-lg font-semibold mb-2">{t(g.key)}</h3>
                  <p className="text-sm text-foreground-500 mb-4">{t(g.desc)}</p>
                  <span className="text-sm font-medium text-primary-600 group-hover:text-primary-700 flex items-center gap-1">
                    {t('guides.readmore')} <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Pillar Articles */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100/50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-wider text-primary-600 mb-3 block">CSSBuy Spreadsheet</span>
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('pillars.title')}</h2>
            <p className="text-foreground-500 max-w-xl mx-auto">{t('pillars.subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {pillarArticles.map((a) => (
              <Link
                key={a.slug}
                to={`/guides/${a.slug}/`}
                className="group bg-white rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all hover:shadow-md"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-semibold text-base mb-2 leading-snug group-hover:text-primary-700 transition-colors">{a.title}</h3>
                  <p className="text-sm text-foreground-500 mb-4 line-clamp-2">{a.excerpt}</p>
                  <span className="text-sm font-medium text-primary-600 group-hover:text-primary-700 flex items-center gap-1">
                    {t('guides.readmore')} <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-primary-500/5">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-semibold mb-4 text-foreground-950">{t('cta.title')}</h2>
          <p className="text-foreground-500 mb-8">{t('cta.subtitle')}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-7 py-3.5 rounded-lg transition-colors whitespace-nowrap"
            >
              {t('cta.btn1')} <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-white hover:bg-background-50 text-foreground-700 font-medium px-7 py-3.5 rounded-lg border border-background-200 transition-colors whitespace-nowrap"
            >
              {t('cta.btn2')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-medium px-7 py-3.5 rounded-lg transition-colors whitespace-nowrap"
            >
              {t('cta.btn3')}
            </a>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold uppercase tracking-wider text-accent-600 mb-3 block">{t('nav.products')}</span>
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">Featured Products</h2>
            <p className="text-foreground-500 max-w-xl mx-auto">Explore our curated selection of products from the CSSBuy Spreadsheet. Click any item to view details and purchase.</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
            {featuredProducts.map((product) => (
              <a
                key={product.id}
                href={product.url}
                target="_blank"
                rel="noopener nofollow"
                className="group bg-white rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-md transition-all duration-300"
              >
                <div className="aspect-square overflow-hidden bg-background-100 relative">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => {
                      (e.target as HTMLImageElement).src = 'https://readdy.ai/api/search-image?query=minimal%20product%20placeholder%20icon%20on%20soft%20gray%20background&width=400&height=400&seq=product-fallback&orientation=squarish';
                    }}
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
                  <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-primary-600">
                      <i className="ri-external-link-line" />
                      Buy
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] md:text-xs font-medium mb-2">
                    {product.category}
                  </span>
                  <h3 className="text-xs md:text-sm font-medium text-foreground-900 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                    {product.title}
                  </h3>
                  <p className="text-sm md:text-base font-bold text-primary-600">
                    {product.price}
                  </p>
                </div>
              </a>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link
              to={i18n.language === 'pt' ? '/produtos/' : i18n.language === 'de' ? '/produkte/' : '/products/'}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-7 py-3.5 rounded-lg transition-colors whitespace-nowrap"
            >
              View All Products <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      {/* Safety */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-foreground-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-12 h-12 rounded-full bg-foreground-800 flex items-center justify-center mx-auto mb-6">
            <i className="ri-shield-check-line text-xl text-primary-400" />
          </div>
          <h2 className="text-2xl md:text-4xl font-semibold mb-4 text-white">{t('safety.title')}</h2>
          <p className="text-foreground-300 leading-relaxed mb-6 max-w-2xl mx-auto">
            {t('safety.text')}
          </p>
          <p className="text-xs text-foreground-500 italic max-w-2xl mx-auto">
            {t('safety.disclaimer')}
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100/50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-semibold mb-4">{t('faq.title')}</h2>
          </div>
          <div className="space-y-3">
            {faqs.map((f, i) => (
              <div key={i} className="bg-white rounded-xl border border-background-200/60 overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left"
                >
                  <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">{t(f.q)}</span>
                  <i className={`ri-${openFaq === i ? 'subtract' : 'add'}-line text-foreground-400 flex-shrink-0`} />
                </button>
                {openFaq === i && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">{t(f.a)}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}